import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/auto-bottom.png';
import _imports_1 from '@/assets/componentImg/auto-bottom-nopublish.png';

const _withScopeId = n => (_pushScopeId("data-v-3e7b91a4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "auto-hide-bar",
  id: "auto-hide-bar2233"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: ""
};
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_7 = {
  key: 1,
  src: _imports_0,
  alt: ""
};
import { ref } from 'vue';
import composition from '@/composition';
import ua from '@/utils/platform';
import { copyTextToClipboard } from '@/utils/regular';
import $ from 'jquery';
export default {
  props: {
    categories: Array,
    model: Object,
    allowPost: {
      default: true,
      type: Boolean
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const url = window.location.href;
    const isMoment = url.includes('/moment') ? true : false;

    function clickOpenApp() {
      if (ua.isMini) {
        copyTextToClipboard(location.href);
        alert('链接复制成功，请您分享给朋友。');
        return;
      }

      if (props.model) {
        openApp();
      } else {
        // 跳转到首页
        openApp(null, true);
      }
    }

    const autoHiderTimer = ref(null); // 监听滚动事件

    window.addEventListener('scroll', function () {
      // 清除之前的滚动定时器
      clearTimeout(autoHiderTimer.value);
      $('#auto-hide-bar2233').fadeOut(500); // console.log('滚动！', vapp.isScrolling);
      // 设置一个新的滚动定时器，如果滚动停止，定时器会在指定的时间后执行

      autoHiderTimer.value = setTimeout(function () {
        // 滚动停止时的处理逻辑
        $('#auto-hide-bar2233').fadeIn(500); // vapp.isScrolling = true
        // console.log('滚动停止了！', vapp.isScrolling);
      }, 500); // 这里的100是检测滚动停止的时间阈值，可以根据需要调整
    });

    const commonClick2233 = () => {
      if (ua.isAndroid) {
        getAppSearch(null, !props.model);
      } else {
        clickOpenApp();
      }
    };

    const {
      openApp,
      getAppSearch
    } = composition(); // const weapp_username = ref('gh_c0321ea144e0')
    // const weapp_path = ref('/packageNews/pages/index/index')

    expose({
      commonClick2233
    });
    return (_ctx, _cache) => {
      const _directive_wx_app = _resolveDirective("wx-app");

      return _unref(ua).isWeixin ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(ua).isAndroid ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "open-btn",
        elId: "launchAppTip",
        appid: "wx27352935c18b925d",
        extInfo: commonClick2233
      }, [!_unref(isMoment) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.allowPost ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))], 64)) : (_openBlock(), _createElementBlock("img", _hoisted_4))])), [[_directive_wx_app]]) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "open-btn",
        onClick: commonClick2233
      }, [!_unref(isMoment) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.allowPost ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : (_openBlock(), _createElementBlock("img", _hoisted_6))], 64)) : (_openBlock(), _createElementBlock("img", _hoisted_7))]))])) : _createCommentVNode("", true);
    };
  }

};